const environmentNames = {
    dev_server: "Dev",
    prod_server: "Production",
    local: "Local"
  };
  
  function getEnvironmentName(envKey) {
    return environmentNames[envKey] || "Unknown Environment";
  }
  
  module.exports = {
    getEnvironmentName
  };
  